import { api } from "..";
import { SimpleSuccessResponse } from "./types";

export const markChatAsUnread = async (
  chatId: number
): Promise<SimpleSuccessResponse> => {
  const res = await api.client.patch(`/chats/${chatId}/unread`);
  return res.data;
};
